var Marionette = require('marionette'),
    Backbone = require('backbone'),
    HitRowView = require('./hitRow/view'),
    HeaderRowView = require('./headerRow/view'),
    RowViewFactory = require('./rowFactory');


/**
 * Initially was a collection view, then babysitter view, which had to be flat -- not hierarchical.
 * Now changed to an array -- should actually become a hierarchy data structure at this point.
 */


module.exports = Marionette.ItemView.extend({

    template: false,

    initialize: function( options ) {

        this.channel = options.channel;
        this.rowViews = []; // remove baby-sitter to check performance improvement
    },

    onBeforeShow: function() {

        var buffer = document.createDocumentFragment();

        var tree = this.channel.request('state').getSearchResultsTree(),
            root = tree.getRoot();

        /* First append the root as the 'header' */
        this.rowViews.push( new HeaderRowView( {
            model: root,
            channel: this.channel
        }) );

        var rootChildren = root.getChildren();

        for ( var level_1_id in rootChildren ) {

            var firstLevelNode = rootChildren[level_1_id],
                childMap = firstLevelNode.getChildren(),
                firstLevelNodeHasMultipleChildren = Object.keys( childMap ).length > 1; // This could be stored on the model ...

            var RowConstructor = RowViewFactory( firstLevelNode );

            this.rowViews.push( new RowConstructor( {
                model: firstLevelNode,
                channel: this.channel
            }) );

            for ( var level_2_id in childMap ) {

                var secondLevelNode = childMap[level_2_id];

                /**
                 * Don't print 'level 2 row if the parent only has one child.
                 * Maybe we just hide -- put attrs has multiple children on them.
                 * TODO: maywe we do only if the page tree ...? see complications in searchRowWithPageLink
                 */
                if ( firstLevelNodeHasMultipleChildren ) {

                    var RowConstructor = RowViewFactory( secondLevelNode );

                    this.rowViews.push( new RowConstructor( {
                        model: secondLevelNode,
                        channel: this.channel
                    } ) );
                }

                _.each( secondLevelNode.getChildren(), function( hit ) {

                    this.rowViews.push( new HitRowView( {
                        model: hit,
                        channel: this.channel
                    }) );

                }, this);

            }
        }

        this.rowViews.forEach( function( view ) {
            //view.triggerMethod('before:show');
            buffer.appendChild( view.render().el );
        });


        // may need to separate beforeShow for the other views, etc ...
        this.attachElContent( buffer );

    },


    onBeforeDestroy: function() {

        this.rowViews.forEach( function(v) {
            v.destroy();
        });

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/rowHierarchyView.js
 ** module id = 616
 ** module chunks = 0
 **/